import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { PersistGate } from "redux-persist/integration/react";
import "./assets/styles/app.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// eslint-disable-next-line
import lodashMixin from "./utils/lodashMixin"; // do not remove this
import store, { persistor } from "./store";
import { SocketProvider } from './components/common/SocketIo'

const theme = createTheme({
  palette: {
    primary: {
      main: "#ff0a90",
    },
  },
});

ReactDOM.render(
  <Provider store={store}>
    <SocketProvider>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </PersistGate>
    </SocketProvider>
  </Provider >,
  document.getElementById("employHER")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
